const props = {
  disabled: {
    type: Boolean,
    default: false
  },
  type: {
    type: [Number, String],
    default: 0
  }
}
export default { props }
export {
  props
}



// WEBPACK FOOTER //
// ./src/components/button/BaseButton.js